export const BulkPlainTypes = {
  INVESTOR_GROUP: 'Investors::InvestorGroup',
  INVESTMENT_VEHICLE: 'Investors::InvestmentVehicle',
  HOLDING: 'Holding',
} as const
